///<reference path="../../../../build/typings/index.d.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/configs/http.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/configs/global.ts" />
///<reference path="controllers/submissions-listing.ts" />

module TotalContest {
    import HttpConfig = TotalCore.Common.Configs.HttpConfig;
    import GlobalConfig = TotalCore.Common.Configs.GlobalConfig;

    export const submission = angular
        .module('submissions-listing', [
            'ngResource',
            'controllers.totalcontest'
        ])
        .config(GlobalConfig)
        .config(HttpConfig)
        .value('ajaxEndpoint', window['totalcontestAjaxURL'] || window['ajaxurl'] || '/wp-admin/admin-ajax.php')
        .value('namespace', 'TotalContest')
        .value('prefix', 'totalcontest');

    export const submissions = {};

    angular.element().ready(function () {
        angular.element('#screen-meta').attr('ng-non-bindable', 0);
        angular.element('#posts-filter').attr('ng-non-bindable', 0);
        angular.element('#wpbody-content').attr('ng-controller', 'SubmissionsListingCtrl as $ctrl');
        angular.bootstrap(document.body, ['submissions-listing']);
    });
}
